export default "__VITE_ASSET__41fe3669__"